export default require('../table/Select').default.concat();


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/form/Select.js
// module id = 277
// module chunks = 0